export class GiftCard {
}
// export class GiftCardVM {
// }
